import * as React from "react";
import Layout from "../../components/Layout";
import image from "../../img/jvc-osa-canada-30th-anniversary-book-cover.png";

export default class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Layout
        pageTitle="30th Anniversary Special Edition Book - JVC OSA Canada"
        pageDescription="30th Anniversary Special Edition Book by JVC OSA Canada."
        pageSlug="/30th-anniversary-book/"
      >
        <section className="section">
          <div className="container">
            <div className="content">
              <h1>30th Anniversary Special Edition Book</h1>
              Click the image below to view the 30th Anniversary Special Edition Book by JVC OSA Canada.
              <br />
              <a href="/files/jvc-osa-canada-30th-anniversary-book.pdf" target="_blank" rel="noopener noreferrer">
                <img src={image} width="50%" alt="30th Anniversary Special Edition Book - JVC OSA Canada" />
              </a>
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
